<template>
<header>
        <nav class="main-nav">
                <ul class="nav-left" :class="{ open: menuOpen }">
                    <li><router-link to="/" :class="{ active: activeLink === 'home' }" @click="setActive('home')">Home</router-link></li>
                    <li><router-link to="/about" :class="{ active: activeLink === 'about' }" @click="setActive('about')">About</router-link></li>
                </ul>

                <div
                    class="logo-container"
                    @click="toggleMenu"
                    @keydown.enter.prevent="toggleMenu"
                    :role="isMobile ? 'button' : undefined"
                    :tabindex="isMobile ? 0 : -1"
                    :aria-expanded="isMobile ? String(menuOpen) : null"
                >
                    <img src="../assets/images/Logo_tinmanworkshop-text.svg" loading="lazy" alt="Logo TinManWorkshop">
                </div>

                <ul class="nav-right" :class="{ open: menuOpen }">
                    <li><router-link to="/games" :class="{ active: activeLink === 'games' }" @click="setActive('games')">Our Games</router-link></li>
                    <li><router-link to="/contact" :class="{ active: activeLink === 'contact' }" @click="setActive('contact')">Contact US</router-link></li>
                </ul>

                <!-- Mobile single-column menu (appears when logo is clicked) -->
                <ul class="mobile-menu" v-show="menuOpen" :class="{ open: menuOpen }" @click.stop>
                    <li><router-link to="/" :class="{ active: activeLink === 'home' }" @click="setActive('home')">Home</router-link></li>
                    <li><router-link to="/about" :class="{ active: activeLink === 'about' }" @click="setActive('about')">About</router-link></li>
                    <li><router-link to="/games" :class="{ active: activeLink === 'games' }" @click="setActive('games')">Our Games</router-link></li>
                    <li><router-link to="/contact" :class="{ active: activeLink === 'contact' }" @click="setActive('contact')">Contact US</router-link></li>
                </ul>
        </nav>
</header>
</template>

<script>
export default {
    name: 'HeaderComponent',
    data() {
        return {
            activeLink: 'home',
            menuOpen: false
            ,isMobile: false
        };
    },
    methods: {
        setActive(link) {
            this.activeLink = link;
            this.menuOpen = false; // chiudi menu dopo la navigazione
        },
        toggleMenu() {
            // Only toggle when in mobile dimensions where icon-only menu is shown
            if (this.isMobile) {
                this.menuOpen = !this.menuOpen;
            }
        }
        ,handleResize() {
            this.isMobile = window.innerWidth <= 768;
            if (!this.isMobile) this.menuOpen = false;
        }
    }
    ,
    mounted() {
        // initialize and listen for resize to detect when only the icon is visible
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style scoped>
header {
    position: sticky;
    top: 0;
    z-index: 100;
    width: 100%;
    background-color: white;
}

header::after {
    content: "";
    position: absolute;
    left: 120px;
    right: 120px;
    bottom: -35px;
    height: 2px;
    background-color: #000;
    opacity: 0.8;
}

.main-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    height: 120px;
    gap: 40px;
}

/* Regole condivise per i due menu laterali */
.nav-left, .nav-right {
    display: flex;
    align-items: center;
    list-style-type: none;
    gap: 40px; /* Questa è la distanza interna tra i link, es: tra "Home" e "About" */
    margin-top: 40px;
    padding: 0;
}

.logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo-container img {
    width: 100px;
    height: 100px;
}

.nav-left li a,
.nav-left li router-link,
.nav-right li a,
.nav-right li router-link {
    text-decoration: none;
    color: black;
    border-bottom: 2px solid transparent;
    font-weight: 700;
    font-size: 25px;
    white-space: nowrap; /* FONDAMENTALE: impedisce che i testi lunghi vadano a capo */
}

.router-link-active {
    border-bottom: 2px solid black !important;
}

/* RESPONSIVE HEADER */
/* Tablet (1024px e sotto) */
@media (max-width: 1024px) {
    header::after {
        left: 60px;
        right: 60px;
        bottom: -20px;
    }
    
    .main-nav {
        min-height: 180px;
        gap: 40px;
    }
    
    .nav-left, .nav-right {
        gap: 40px;
        margin-top: 40px;
    }
    
    .logo-container img {
        width: 150px;
        height: 150px;
    }
    
    .nav-left li a,
    .nav-right li a {
        font-size: 24px;
    }
}

/* Tablet medio (768px e sotto) */
@media (max-width: 768px) {
    header::after {
        left: 30px;
        right: 30px;
        bottom: -15px;
    }
    
    .main-nav {
        min-height: 140px;
        gap: 20px;
        flex-wrap: wrap;
        position: relative; /* necessario per posizionare il menu dropdown */
    }
    
    /* Nascondi i menu laterali per mostrare solo il logo; si aprono se hanno la classe .open */
    .nav-left, .nav-right {
        display: none;
    }

    .nav-left.open,
    .nav-right.open {
        display: flex;
        flex-direction: column;
        gap: 12px;
        position: absolute;
        left: 0;
        right: 0;
        top: 100%;
        background: white;
        padding: 12px 16px 18px 16px;
        box-shadow: 0 8px 30px rgba(0,0,0,0.12);
    }

    .nav-left.open li,
    .nav-right.open li {
        text-align: center;
        width: 100%;
        padding: 8px 0;
    }

    .logo-container {
        order: -1;
        width: 100%;
        margin-bottom: 10px;
        cursor: pointer;
    }
    
    .logo-container img {
        width: 120px;
        height: 120px;
    }
    
    .nav-left li a,
    .nav-right li a {
        font-size: 16px;
    }
}

/* Mobile (576px e sotto) */
@media (max-width: 576px) {
    header::after {
        left: 10px;
        right: 10px;
        bottom: -10px;
        height: 1px;
    }
    
    .main-nav {
        min-height: 110px;
        gap: 10px;
        flex-direction: column;
        justify-content: flex-start;
        padding: 10px 0;
        position: relative;
    }
    
    .nav-left, .nav-right {
        display: none;
    }

    .nav-left.open,
    .nav-right.open {
        display: flex;
        flex-direction: column;
        gap: 10px;
        position: absolute;
        left: 0;
        right: 0;
        top: 100%;
        background: white;
        padding: 10px 12px;
        box-shadow: 0 8px 24px rgba(0,0,0,0.12);
    }

    .logo-container img {
        width: 100px;
        height: 100px;
    }
    
    .nav-left li a,
    .nav-right li a {
        font-size: 13px;
        padding: 8px 6px;
    }

    .mobile-menu{
        display:none;
    }
}

/* Mobile single-column menu style */
@media (max-width: 768px) {
    .mobile-menu {
        display: flex;
        flex-direction: column;
        gap: 10px;
        position: absolute;
        left: 0;
        right: 0;
        list-style: none;
        top: 100%;
        background: white;
        padding: 12px 16px 18px 16px;
        box-shadow: 0 10px 40px rgba(0,0,0,0.15);
        z-index: 120;
        align-items: center;
        overflow: hidden;
        max-height: 0; /* collapsed by default */
        opacity: 0;
        transform: translateY(-8px);
        transition: max-height 300ms ease, opacity 220ms ease, transform 260ms ease;
    }

    .mobile-menu li {
        width: 100%;
        text-align: center;
        padding: 8px 0;
    }

    .mobile-menu li a {
        font-size: 16px;
        text-decoration: none;
        font-weight: 700;
        color: #000;
    }
    .mobile-menu.open {
        max-height: 520px; /* large enough to show all items */
        opacity: 1;
        transform: translateY(0);
        padding: 12px 16px 18px 16px; /* restore padding when open */
    }
}

/* Ultra-mobile (480px e sotto) */
@media (max-width: 480px) {
    header::after {
        display: none;
    }
    
    .main-nav {
        min-height: 90px;
        gap: 5px;
    }
    
    .nav-left, .nav-right {
        display: none;
    }
    
    .logo-container img {
        width: 80px;
        height: 80px;
    }
    
    .nav-left.open,
    .nav-right.open {
        padding: 8px 12px 12px 12px;
    }
    
    .nav-left li a,
    .nav-right li a {
        font-size: 11px;
        padding: 6px 4px;
    }
}
</style>